import e, { forwardRef as _ } from "react";
import { Info as n, XCircle as s, Check as d, AlertTriangle as x } from "@olxbr/ds-icons";
import { Text as p } from "../Text/Text.js";
import { cls as E } from "../../helpers/cls.js";
typeof window != "undefined" && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = "3.35.0");
const f = _ref => {
    let {
      variant: t
    } = _ref;
    const r = {
      default: n,
      error: s,
      success: d,
      warning: x,
      information: n
    }[t];
    return e.createElement(r, null);
  },
  i = _((_ref2, m) => {
    let {
      variant: t = "default",
      role: r,
      icon: l,
      title: a,
      children: c,
      time: o = ""
    } = _ref2;
    return e.createElement("div", {
      "data-ds-componet": "DS-Alertbox",
      ref: m,
      className: E("olx-alertbox", "olx-alertbox--".concat(t)),
      role: !r && t === "error" ? "alert" : r != null ? r : "status",
      title: a
    }, e.createElement("div", {
      className: "olx-alertbox__content-wrapper"
    }, e.createElement("span", {
      className: "olx-alertbox__icon-wrapper",
      "aria-hidden": !0
    }, l != null ? l : e.createElement(f, {
      variant: t
    })), e.createElement("div", {
      className: "olx-alertbox__content"
    }, e.createElement("span", {
      className: "olx-alertbox__title",
      title: a
    }, a), e.createElement("div", {
      className: "olx-alertbox__description"
    }, c))), !!o && e.createElement("div", {
      className: "olx-alertbox__time-wrapper"
    }, e.createElement(p.Caption, {
      tag: "p"
    }, o)));
  });
i.displayName = "Alertbox";
export { i as Alertbox };